import React from 'react';
import propTypes from 'prop-types';
import { TextField } from '@johnlewispartnership/wtr-ingredients/dist/Forms';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { OPTIONAL_ADDRESS_FIELD, POSTCODE_FIELD, REQUIRED_FIRST_ADDRESS_FIELD, TOWN_FIELD, COUNTY_FIELD, } from '../../../../components/CompetitionsForms/constants';
import styles from '../../CompetitionsForm.module.scss';
const AddressSection = ({ form: { errors, register } }) => {
    var _a, _b, _c, _d, _e;
    return (React.createElement("div", { className: styles.sectionWrapper, "data-testid": "address-section" },
        React.createElement(Typography, { styleAs: "sectionHeadingLight", element: "h3" }, "Your address"),
        React.createElement(TextField, { errorText: (_a = errors.addressLine1) === null || _a === void 0 ? void 0 : _a.message, id: "addressLine1", label: "Address 1", name: "addressLine1", ref: register(REQUIRED_FIRST_ADDRESS_FIELD) }),
        React.createElement(TextField, { errorText: (_b = errors.addressLine2) === null || _b === void 0 ? void 0 : _b.message, id: "addressLine2", label: "Address 2 (optional)", name: "addressLine2", ref: register(OPTIONAL_ADDRESS_FIELD) }),
        React.createElement(TextField, { errorText: (_c = errors.town) === null || _c === void 0 ? void 0 : _c.message, id: "town", label: "Town", name: "town", ref: register(TOWN_FIELD) }),
        React.createElement(TextField, { errorText: (_d = errors.county) === null || _d === void 0 ? void 0 : _d.message, id: "county", label: "County", name: "county", ref: register(COUNTY_FIELD) }),
        React.createElement(TextField, { errorText: (_e = errors.postalCode) === null || _e === void 0 ? void 0 : _e.message, id: "postalCode", label: "Postcode", name: "postalCode", ref: register(POSTCODE_FIELD) })));
};
AddressSection.propTypes = {
    form: propTypes.shape({
        errors: propTypes.objectOf(propTypes.shape({
            ref: propTypes.shape({ scrollIntoView: propTypes.func, focus: propTypes.func }),
            type: propTypes.string,
            message: propTypes.string,
        })),
        register: propTypes.func.isRequired,
    }).isRequired,
};
export default AddressSection;
//# sourceMappingURL=index.js.map